import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VTextField, {
    staticClass: "input-with-add-button",
    attrs: {
      "value": _vm.value,
      "label": _vm.label,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "color": _vm.color,
      "dense": _vm.dense,
      "hide-details": "",
      "data-cy": "text_value",
      "readonly": _vm.readonly
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', $event);
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.$emit('add-rule');
      }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [_c('core-button', {
          staticClass: "rule-add-button",
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.canAddRule,
            "prepend-icon": "fa-plus",
            "data-cy": "button_add_rule"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('add-rule');
            }
          }
        })];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };